module.exports = __webpack_public_path__ + "static/media/dojo-group-2.a1259420.jpg";